<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import ChannelService from "./util/ChannelTalk.js";

    export let currentRoute;
    export let params;
    let timestamp = Date.now();
    let iframe;
    let botId = currentRoute.namedParams.botId;
    let url = "about:blank";
	let isLoad = true;

    // 빌더(Preview.svelte)에서 온 하이라이트 메시지를 내부 prd(React) iframe으로 릴레이.
    // postMessage는 직계 자식까지만 전달되므로 중간 단계인 View가 한 번 더 넘겨준다.
    const relayHighlight = (e) => {
        const d = e.data;
        if (!d || d.source !== "avatalk-builder") return;
        console.log("[highlight][View] 수신 → 내부 iframe으로 릴레이", d, iframe);
        iframe?.contentWindow?.postMessage(d, "*");
    };

    onMount(() => {
        window.addEventListener("message", relayHighlight);
        ChannelIO('shutdown');
        /*
        PRConnect.send("/api/Message/viewBotInfo", {botId}, data => {
            let charInfo = data.result;
       
            if( charInfo.charType === "3D") {
                url += "&gltf=" + charInfo.gltfContent;
            }
            
            iframe.src = url;
        });
        */
        url = `/static/avatalk/${botId}/prd/index.html?timestamp=${timestamp}`;
        if (botId.includes("@")) {
			isLoad = false;
            PRConnect.send("/api/Bot/getBotByDesignateUrl", { designateUrl : botId.split("@")[1]}, data => {
                document.querySelector("title").innerHTML = data.result.title + " - AVATALK";
                url = `/static/avatalk/${data.result.id}/prd/index.html?timestamp=${timestamp}`;
				isLoad = true;
            });
        } else {
            PRConnect.send("/api/Bot/getBotByBotId", { id : botId, log : "ACCESS"}, data => {
                if( data.header.status === "success") {
                    document.querySelector("title").innerHTML = data.result.title + " - AVATALK";
                }
            });
        }
        
    });

    onDestroy(() => {
        window.removeEventListener("message", relayHighlight);
    });

    ChannelIO('shutdown');
</script>
<div class="wrapper">
	{#if isLoad}
    <iframe bind:this={iframe} src="{url}" frameBorder="0" class="iframe" scrolling="no" referrerpolicy="no-referrer" />
	{/if}
</div>

<style>
.wrapper > iframe {
    width: 100%;
    height: 100vh;
}
::-webkit-scrollbar {
  display: none;
}

</style>